export const CONTACT = {
  company: "KFZ-Sachverständigenbüro Björn Linkowitz",
  street: "Zimmermannsgasse 3",
  city: "15366 Hoppegarten",
  phone: "030 68 30 23 00",
  phoneRaw: "+493068302300",
  fax: "030 68 30 23 02",
  email: "info@classic-data.berlin",
  whatsapp: "+493068302300",
  hours: "Montag bis Freitag 9 – 18 Uhr",
  hoursShort: "Mo – Fr · 9 – 18 Uhr",
  hoursNote: "oder nach Vereinbarung",
  mapsQuery: "Zimmermannsgasse+3+15366+Hoppegarten",
};

export const NAV = [
  { label: "Startseite", to: "/" },
  { label: "Leistungen", to: "/leistungen" },
  { label: "Über uns", to: "/ueber-uns" },
  { label: "Referenzen", to: "/referenzen" },
  { label: "Kontakt", to: "/kontakt" },
];

export const IMAGES = {
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_f355f869-c66f-46f0-b0a2-5bf385cad63c/artifacts/85m6i761_Classic%20Data%20Logo.jpg",
  heroHero: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/nr7p51xx_ChatGPT%20Image%2020.%20Aug.%202026%2C%2013_25_43.png",
  heroHero2: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/y41daz5r_ChatGPT%20Image%2018.%20Aug.%202026%2C%2016_01_33.png",
  expertCadillac: "https://customer-assets-jt897jd0.emergentagent.net/job_f355f869-c66f-46f0-b0a2-5bf385cad63c/artifacts/egyayioq_KFZ%20Linkowitz%20Webaufl%C3%B6sung%20%2893%20von%20148%29.jpg",
  work1: "https://customer-assets-jt897jd0.emergentagent.net/job_f355f869-c66f-46f0-b0a2-5bf385cad63c/artifacts/vfedzjtv_KFZ%20Linkowitz%20Webaufl%C3%B6sung%20%286%20von%20148%29.jpg",
  work2: "https://customer-assets-jt897jd0.emergentagent.net/job_f355f869-c66f-46f0-b0a2-5bf385cad63c/artifacts/70be6ifm_KFZ%20Linkowitz%20Webaufl%C3%B6sung%20%284%20von%20148%29.jpg",
  work3: "https://customer-assets-jt897jd0.emergentagent.net/job_f355f869-c66f-46f0-b0a2-5bf385cad63c/artifacts/r8mg16cw_KFZ%20Linkowitz%20Webaufl%C3%B6sung%20%282%20von%20148%29.jpg",
  porsche: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/mq8xeygk_20260624_075715091_iOS.webp",
  mercedes: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/8h7qfga4_dbeccbd0-8b74-49a7-8a0c-80aeec339473.webp",
  jaguar: "https://images.unsplash.com/photo-1671653892082-6699cc445245?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  engine: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/mq3pkwgr_20260719_085757461_iOS.webp",
  office: "https://customer-assets-jai6qajn.emergentagent.net/job_collector-trust-1/artifacts/u2vev0aa_PHOTO-2026-08-18-16-44-52.jpg",
  workshop: "https://images.unsplash.com/photo-1486684146097-cdfdd7dcb1cf?auto=format&fit=crop&q=85&w=1600",
  dashboard: "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=85&w=1600",
  chrome: "https://images.unsplash.com/photo-1570468030291-1dcfea55e2ad?auto=format&fit=crop&q=85&w=1600",
  garage: "https://images.unsplash.com/photo-1550855297-cf2b7b3f2d6c?auto=format&fit=crop&q=85&w=1600",
  wheel: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&q=85&w=1600",
};

export const SERVICES = [
  {
    slug: "kurzbewertung",
    number: "01",
    title: "Kurzbewertung",
    tagline: "Zur Versicherungseinstufung",
    short: "Äußerliche Inaugenscheinnahme, keine detaillierte Untersuchung.",
    ideal: "Ideal für Halter, die eine schnelle, versicherungstaugliche Werteinschätzung ihres Klassikers benötigen.",
    image: "porsche",
    description: "Die Kurzbewertung liefert Ihnen eine belastbare Werteinschätzung Ihres Oldtimers oder Youngtimers für Versicherungszwecke — kompakt, präzise und praxisnah. Wir dokumentieren den äußerlichen Zustand des Fahrzeuges, prüfen die zentralen Identifikationsmerkmale und stufen Ihren Wagen anhand der Classic-Data Marktbeobachtung ein.",
    includes: [
      "Äußerliche Inaugenscheinnahme des Fahrzeuges",
      "Fotodokumentation im Classic-Data Standard",
      "Marktwertermittlung nach Zustandsnoten 1 – 5",
      "Anerkennung durch alle führenden Klassikerversicherungen",
    ],
  },
  {
    slug: "ausfuehrliche-fahrzeugbewertung",
    number: "02",
    title: "Ausführliche Fahrzeugbewertung",
    tagline: "Vollständige Begutachtung inkl. Probefahrt",
    short: "Sorgfältige Begutachtung des Fahrzeuges inkl. Baugruppen, Fahrzeugunterseite, Probefahrt.",
    ideal: "Ideal beim Kauf, Verkauf oder bei einer umfassenden Neu­bewertung eines wertvollen Klassikers.",
    image: "mercedes",
    description: "Die ausführliche Fahrzeugbewertung ist unser umfassendstes Gutachten. Wir untersuchen jedes einzelne Detail Ihres Fahrzeuges — von Karosserie und Lack über sämtliche Baugruppen und die Fahrzeugunterseite bis hin zur ausgiebigen Probefahrt. Sie erhalten ein detailliertes Gutachten, das Zustand, Wert und Historie Ihres Klassikers unabhängig dokumentiert.",
    includes: [
      "Detaillierte Begutachtung sämtlicher Baugruppen",
      "Inspektion der Fahrzeugunterseite auf der Hebebühne",
      "Ausgiebige Probefahrt und Funktionsprüfung",
      "Umfassende Foto- und Textdokumentation",
      "Marktwert- und Wiederbeschaffungswertermittlung",
    ],
  },
  {
    slug: "schadengutachten-nach-unfall",
    number: "03",
    title: "Schadengutachten",
    tagline: "Nach Unfall — Kasko- oder Haftpflichtschaden",
    short: "Gutachten Kaskoschaden bzw. Haftpflichtschaden.",
    ideal: "Ideal nach einem Unfall — sichert die faire Regulierung durch die Versicherung.",
    image: "engine",
    description: "Nach einem Unfall geht es um mehr als nur um Blech: es geht um Ihren Klassiker und um die faire Regulierung durch die Versicherung. Wir erstellen unabhängige Schadengutachten für Kasko- und Haftpflichtschäden und vertreten dabei ausschließlich Ihre Interessen.",
    includes: [
      "Unabhängige Schadensaufnahme vor Ort",
      "Ermittlung der Reparaturkosten nach klassikergerechten Standards",
      "Wertminderung, Wiederbeschaffungs- und Restwertermittlung",
      "Gutachten für Kasko- und Haftpflichtversicherer anerkannt",
    ],
  },
];

export const INSURERS = [
  "ADAC", "Allianz", "AXA", "Gothaer", "HDI", "Hiscox", "LVM",
  "Mannheimer / Belmot", "Nürnberger", "Herzenssache", "OCC", "Carisma",
  "Signal", "Württembergische", "Zurich",
];

export const MARQUES = [
  "Porsche", "Mercedes-Benz", "Jaguar", "Cadillac", "BMW", "Alfa Romeo",
  "Ferrari", "Aston Martin", "Bentley", "Citroën", "Lancia", "Ford Mustang",
];

export const STATS = [
  { value: 22, suffix: "+", label: "Jahre Erfahrung", note: "Seit 2002 Vertragspartner der Classic Data GmbH" },
  { value: 4500, suffix: "+", label: "Bewertete Fahrzeuge", note: "Oldtimer, Youngtimer, US-Cars und Modern Classics" },
  { value: 98, suffix: "%", label: "Zufriedene Kunden", note: "Wiederkehrende Halter und Sammler" },
  { value: 24, suffix: " Std.", label: "Reaktionszeit", note: "Antwort auf Ihre Anfrage — meist schneller" },
];

export const TESTIMONIALS = [
  {
    name: "Andreas W.",
    car: "1971 Porsche 911 T",
    rating: 5,
    quote: "Herr Linkowitz hat sich Zeit genommen, mein Fahrzeug wirklich zu verstehen. Das Gutachten war so präzise, dass meine Versicherung ohne Diskussion zugestimmt hat.",
    image: "porsche",
  },
  {
    name: "Christine S.",
    car: "1965 Mercedes-Benz 230 SL",
    rating: 5,
    quote: "Nach einem kleinen Auffahrunfall wurde der Wagen meines Mannes fair und schnell bewertet. Ich hatte das Gefühl, dass hier jemand steht, der Klassiker liebt.",
    image: "mercedes",
  },
  {
    name: "Dr. Michael H.",
    car: "1963 Jaguar E-Type Coupé",
    rating: 5,
    quote: "Absolut professionell und unabhängig. Für meinen E-Type war das genau der Experte, den ich gesucht habe. Klare Empfehlung aus Berlin und weit darüber hinaus.",
    image: "jaguar",
  },
];

export const PROCESS = [
  { n: "01", title: "Kontakt", text: "Sie rufen an oder senden uns Ihre Anfrage. Wir hören zu, verstehen Ihr Anliegen und beraten kostenfrei zur passenden Gutachtenform." },
  { n: "02", title: "Termin", text: "Wir vereinbaren einen Termin — bei Ihnen vor Ort, in einer Werkstatt oder in unserem Büro in Hoppegarten bei Berlin." },
  { n: "03", title: "Inaugenscheinnahme", text: "Wir begutachten Ihr Fahrzeug ausführlich, dokumentieren jedes relevante Detail und führen — falls beauftragt — eine Probefahrt durch." },
  { n: "04", title: "Gutachten", text: "Sie erhalten ein belastbares, versicherungstaugliches Gutachten mit Marktwerteinstufung nach Classic-Data Standard." },
];

export const TEAM = [
  {
    name: "Björn Linkowitz",
    role: "Geschäftsführer · Kfz-Sachverständiger",
    note: "BVSK · Vertragspartner Classic Data seit 2002",
    img: "work3",
  },
  {
    name: "Sabine Linkowitz",
    role: "Prokuristin",
    note: "Buchhaltung, Mahnwesen und Gutachten­bearbeitung · Gelernte Rechtsanwalts- und Notarfachangestellte",
    img: "work2",
  },
  {
    name: "Sandra Wienigk",
    role: "Bürokauffrau",
    note: "Kundenbetreuung, Terminorganisation und Auftrags­bearbeitung",
    img: "work1",
  },
];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?sa=X&sca_esv=df1cf69e39475cc9&hl=de-DE&q=Bj%C3%B6rn+Linkowitz+KFZ+Sachverst%C3%A4ndigenb%C3%BCro+Reviews&stick=H4sIAAAAAAAAAONgkxIxtDAwMbI0MrQ0NDUzNzC1MDK1NNzAyPiK0dgp6_C2ojwFn8y87PzyzJIqBW-3KIXgxOSMstSi4pLDS_JSMtNT85IO7ynKVwhKLctMLS9exEqOLgCa3e_vhwAAAA&rldimm=18042921915670582591#lkt=LocalPoiReviews";

export const EVENTS = [
  {
    date: "24. – 25. August 2024",
    title: "US Car Classics 2024",
    location: "Schloss Diedersdorf",
    text: "Sie finden unseren Pavillon auf dem Gelände. Wie immer: Nach dem gelben Sonnenschirm Ausschau halten oder kurz durchrufen unter 030 68 30 23 00. Falls Sie eine Classic-Data Bewertung oder eine Aktualisierung Ihrer Bewertung wünschen — wir sind gerne für Sie da.",
    img: "jaguar",
  },
  {
    date: "18. – 20. Mai 2024",
    title: "Die Oldtimer Show 2024",
    location: "ADAC Linthe",
    text: "Sie finden unseren Pavillon auf dem Gelände. Wie immer: Nach dem gelben Sonnenschirm Ausschau halten oder kurz durchrufen unter 030 68 30 23 00.",
    img: "mercedes",
  },
  {
    date: "27. – 29. Mai 2023",
    title: "Die Oldtimer Show 2023",
    location: "ADAC Linthe",
    text: "Sie finden unseren Pavillon auf dem Gelände. Nach dem gelben Sonnenschirm Ausschau halten oder kurz durchrufen unter 030 68 30 23 00.",
    img: "porsche",
  },
  {
    date: "26. – 27. August 2023",
    title: "US Car Classics 2023",
    location: "Schloss Diedersdorf",
    text: "Am letzten Augustwochenende treffen sich klassische Amis der letzten 100 Jahre Automobilgeschichte im herrschaftlichen Garten von Schloss Diedersdorf, um die Luft des amerikanischen Kults vergangener Zeiten zu atmen.",
    img: "engine",
  },
];

export const CHAPTERS = [
  {
    n: "01",
    kicker: "Unabhängigkeit",
    title: "Wir arbeiten für Sie.",
    text: "Unsere Gutachten sind neutral, unabhängig und ausschließlich Ihren Interessen als Halter verpflichtet. So entstehen belastbare Werte, denen Sie und Ihre Versicherung vertrauen können.",
  },
  {
    n: "02",
    kicker: "Erfahrung",
    title: "Seit 2002 Vertragspartner der Classic Data GmbH.",
    text: "Zwei Jahrzehnte, tausende bewertete Klassiker und die tägliche Arbeit mit dem Fahrzeug — das ist die Grundlage, auf der wir Wert und Zustand Ihres Automobils fair einschätzen.",
  },
  {
    n: "03",
    kicker: "Anerkennung",
    title: "Von allen führenden Klassiker­versicherungen anerkannt.",
    text: "ADAC, Allianz, Axa, Gothaer, HDI, Hiscox, LVM, Mannheimer/Belmot, Nürnberger, M.O.V.E., OCC, Olasko, OVD, Signal Württembergische, Zurich.",
  },
  {
    n: "04",
    kicker: "Persönlich",
    title: "Wir wissen, was Ihr Fahrzeug Ihnen bedeutet.",
    text: "Für viele unserer Kunden ist ihr Klassiker mehr als ein Auto: er ist Erinnerung, Handwerk, Erbstück und Traum zugleich. Wir behandeln jedes Fahrzeug mit dem Respekt, den es verdient.",
  },
];
